import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import InputImageField from 'components/molecules/input-image-field'
import LoaderButton from 'components/molecules/loader-button'

const propTypes = {
  title                    : PropTypes.string,
  onClickAttachImage       : PropTypes.func,
  onFileSelectionError     : PropTypes.func,
  onSelectCoverPreview     : PropTypes.func,
  multiple                 : PropTypes.bool,
  isImageAttachLoading     : PropTypes.bool,
  setIsImageAttachLoading  : PropTypes.func,
  showAttachImageButton    : PropTypes.bool,
  setShowAttachImageButton : PropTypes.func
}

const defaultProps = {
  title                    : '',
  onClickAttachImage       : () => {},
  onFileSelectionError     : () => {},
  onSelectCoverPreview     : () => {},
  multiple                 : true,
  isImageAttachLoading     : false,
  setIsImageAttachLoading  : () => { },
  showAttachImageButton    : false,
  setShowAttachImageButton : () => {}
}

/**
 * @param {string} title - a string that's going to be the header of the upload card
 * @param {func} onClickAttachImage - a function that will be called when attach image button is clicked
 * @param {func} onFileSelectionError - a function that will be passed to InputImageField, and will be called when the selected file doesn't match the requirement
 * @param {func} onSelectCoverPreview - a function that will be run when a new cover is selected
 * @param {boolean} multiple - a boolean to determine whether a user can upload multiple files or not
 * @param {boolean} isImageAttachLoading - a boolean to determine whether Image is in process of attaching or not
 * @param {func} setIsImageAttachLoading - a function to set isImageAttachLoading true or false
 * @param {boolean} showAttachImageButton - a boolean to determine whether to show Attach Image Button or not
 * @param {func} setShowAttachImageButton - a function to set showAttachImageButton true or false
 */

const ScraperProductAttachImageCard = ({
  title,
  onClickAttachImage,
  onFileSelectionError,
  multiple,
  isImageAttachLoading,
  setIsImageAttachLoading,
  showAttachImageButton,
  setShowAttachImageButton,
  ...props
}) => {
  const [ chosenImages, setChosenImages ] = useState([])

  useEffect(() => {
    if (chosenImages.length > 0) {
      setShowAttachImageButton(true)
    }
  },[ setShowAttachImageButton, chosenImages ])

  const handleSubmit = () => {
    setIsImageAttachLoading(true)
    const imageData = { images: chosenImages }
    onClickAttachImage(imageData)
  }

  const fileInputRef = useRef()

  return (
    <Card>
      {
        title && (
          <CardHeader>
            <h4><b>{ title }</b></h4>
          </CardHeader>
        )
      }
      <CardBody>
        <InputImageField
          onSelectImages={ setChosenImages }
          onFileSelectionError={ onFileSelectionError }
          ref={ fileInputRef }
          multiple={ multiple }
          allowAllAspectRatio={ true }
          { ... props }
        />
        {
          showAttachImageButton && (
            <LoaderButton
              className='mt-3'
              color='primary'
              onClick={ handleSubmit }
              isLoading={ isImageAttachLoading }
              disabled={ isImageAttachLoading }
              text = 'Attach Image(s)'
            />
          )
        }
      </CardBody>
    </Card>
  )
}

ScraperProductAttachImageCard.propTypes    = propTypes
ScraperProductAttachImageCard.defaultProps = defaultProps

export default ScraperProductAttachImageCard
